import type { DecisionCaseDto, LlmChatAttachmentDto, ProjectConceptDto } from '@paladin-monorepo/common';

export interface InquiryCreateLocationState {
  chatDraft?: unknown;
  chatSessionId?: string;
  chatAttachments?: LlmChatAttachmentDto[];
  fromConcept?: ProjectConceptDto;
  fromDecisionCase?: DecisionCaseDto;
  decisionCaseId?: string;
}

export function buildInquiryCreateRoute(projectConceptId?: string | null): string {
  return projectConceptId
    ? `/inquiries/new?conceptId=${encodeURIComponent(projectConceptId)}`
    : '/inquiries/new';
}

export function buildInquiryCreateState(opts: {
  chatDraft: unknown;
  chatSessionId: string;
  chatAttachments: LlmChatAttachmentDto[];
}): InquiryCreateLocationState {
  const { chatDraft, chatSessionId, chatAttachments } = opts;
  return { chatDraft, chatSessionId, chatAttachments };
}

/** Pick concept id from router bootstrap or URL query param. */
export function resolveConceptIdFromSources(opts: {
  fromConcept?: ProjectConceptDto;
  urlConceptId?: string | null;
}): string | undefined {
  return opts.fromConcept?.id ?? opts.urlConceptId ?? undefined;
}
